import { z } from "zod";
import { IsoDateTime } from "./common.ts";

/**
 * Access token handed to the Spotify Web Playback SDK. Phase 16 locks this
 * behind app auth — fine on localhost, not on a public host.
 */
export const PlaybackTokenSchema = z.object({
  access_token: z.string().min(1),
  expires_at: IsoDateTime,
});

export type PlaybackToken = z.infer<typeof PlaybackTokenSchema>;
